import { render } from "./Profile.vue?vue&type=template&id=648da1d3&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=648da1d3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-648da1d3"

export default script